/** Stable id of the bundled SRD 5.2.1 content pack. */
export const SRD_PACK_ID = 'srd-5.2.1'
